// Feedback copy is maintained locally; a future server configuration can replace this catalog.
// Keep wording respectful: no promises of automatic learning or guaranteed fixes.
export const feedbackTitles = Object.freeze([
  '这次没接稳，帮我指个方向？',
  '看来还差点意思，听听你的建议',
  '哪里跑偏了？帮我点出来',
  '收到，这次还有进步空间',
  '抱歉，这次没帮到点上',
  '这次有点掉链子，抱歉啦',
  '离你想要的还差一点，听你说说',
  '抱歉，刚才可能没跟上你的思路',
  '这次答得不够漂亮，接受指点',
  '这次没拿到小红花，听听你的意见',
  '接受批评，努力进步',
  '这次配合得不够默契，听你指点',
  '谢谢你指出不足，建议很宝贵',
  '这次还不够到位，你的意见我认真收下',
  '抱歉，距离靠谱助理还差这一小步',
  '这次表现欠佳，欢迎给我提个醒'
])
export const feedbackCopy = Object.freeze({
  prompt: '哪里需要改进？可多选，也可以补充说明',
  placeholder: '选填，比如：我只想看客厅设备，却看到了所有房间',
  skip: '暂不补充', submit: '提交补充', saving: '保存中…',
  dislikeSaved: '感谢反馈，不满意已记录',
  detailSaved: '谢谢，补充反馈已收到', likeSaved: '谢谢，反馈已记录'
})
// Choose once when opening the panel, never during rendering or typing.
export function pickFeedbackTitle(previous, random = Math.random) {
  const choices = feedbackTitles.filter(title => title !== previous)
  return choices[Math.min(choices.length - 1, Math.floor(random() * choices.length))]
}

export function reasonCodes(codes = []) {
  return [...new Set(codes)];
}
